import { lazy } from 'react';

export const AppTimeline = lazy(() =>
  import(/* webpackChunkName: "AppTimeline" */ './AppTimeline').then((module) => ({
    default: module.AppTimeline,
  }))
);
export type { TimelineModuleID } from './types';
export * from './constants';
